import { createQueryKeys } from '@lukemorales/query-key-factory';

import type {
  FetchModuleByIdArgs,
  FetchModulesArgs,
} from '../api/types/modules.types';

import {
  fetchModuleStatistics,
  fetchModuleById,
  fetchModules,
} from '../api/modules.api';

export const modulesQueryKeys = createQueryKeys('educationModules', {
  fetchInfiniteModules: ({
    contentFilters,
    locale,
    organizationId,
    tableFilters,
  }: FetchModulesArgs) => ({
    queryFn: (context?: { pageParam?: unknown }) =>
      fetchModules({
        contentFilters,
        locale,
        organizationId,
        tableFilters: {
          ...tableFilters,
          offset: (context?.pageParam as string) || '1',
        },
      }),
    queryKey: [organizationId, contentFilters, tableFilters],
  }),
  fetchModuleById: ({ id, locale, organizationId }: FetchModuleByIdArgs) => ({
    queryFn: () => fetchModuleById({ id, locale, organizationId }),
    queryKey: [organizationId, id],
  }),
  fetchModuleStatistics: ({
    id,
    locale,
    organizationId,
  }: FetchModuleByIdArgs) => ({
    queryFn: () => fetchModuleStatistics({ id, locale, organizationId }),
    queryKey: [organizationId, id, 'statistics', locale],
  }),
  fetchModules: ({
    contentFilters,
    locale,
    organizationId,
    tableFilters,
  }: FetchModulesArgs) => ({
    queryFn: () =>
      fetchModules({ contentFilters, locale, organizationId, tableFilters }),
    queryKey: [organizationId, contentFilters, tableFilters],
  }),
});
